import { generateWebAppSignedUrl } from '@app/modules/fragments/lib/generate-web-app-signed-url';
import { useMemo } from 'react';

export type SubtitleDownloadUrls = {
  txt: string;
  srt: string;
  json: string;
};

/**
 * Builds signed GET URLs for fragment subtitle exports (Web App BFF).
 * Recomputes when the fragment id or speaker-id option changes.
 */
export function useFragmentSubtitleDownloadUrls(
  fragmentId: string | undefined,
  withSpeakerId: boolean,
): SubtitleDownloadUrls | null {
  return useMemo(() => {
    if (!fragmentId) {
      return null;
    }

    const path = `/web-app/fragments/${fragmentId}/subtitles`;
    const common = { download: true as const, withSpeakerId };

    return {
      txt: generateWebAppSignedUrl(path, { ...common, format: 'txt' }),
      srt: generateWebAppSignedUrl(path, { ...common, format: 'srt' }),
      json: generateWebAppSignedUrl(path, { ...common, format: 'json' }),
    };
  }, [fragmentId, withSpeakerId]);
}
